import React from 'react';
import { HomeIcon, WalletIcon, QrCodeIcon, CreditCardIcon, SettingsIcon } from 'lucide-react';
export type NavTarget = 'home' | 'accounts' | 'qr' | 'cards' | 'settings';
export function BottomNav({
  active,
  onNavigate
}: {
  active: NavTarget;
  onNavigate?: (t: NavTarget) => void;
}) {
  return <div className="relative" data-id="element-132">
      <div className="flex items-end justify-around px-2 pt-2 pb-2" style={{
      backgroundColor: '#FFFFFF',
      borderTop: '1px solid #E5EAF0'
    }} data-id="element-133">
        <NavItem icon={<HomeIcon size={22} data-id="element-135" />} label="Home" active={active === 'home'} onClick={() => onNavigate?.('home')} data-id="element-134" />
        <NavItem icon={<WalletIcon size={22} data-id="element-137" />} label="Accounts" active={active === 'accounts'} onClick={() => onNavigate?.('accounts')} data-id="element-136" />
        <div className="relative flex flex-col items-center" style={{
        width: 64
      }} data-id="element-138">
          <button type="button" aria-label="QR Payments" onClick={() => onNavigate?.('qr')} className="absolute -top-7 flex items-center justify-center rounded-full transition-all active:scale-[0.96]" style={{
          width: 60,
          height: 60,
          backgroundColor: '#009AC7',
          color: '#FFFFFF',
          boxShadow: '0 12px 24px -8px rgba(0,154,199,0.55), 0 0 0 6px rgba(244,247,250,1)'
        }} data-id="element-139">
            <QrCodeIcon size={26} data-id="element-140" />
          </button>
          <span className="mt-9" style={{
          fontSize: 10.5,
          fontWeight: 600,
          color: '#1A1A1A'
        }} data-id="element-141">
            QR Pay
          </span>
        </div>
        <NavItem icon={<CreditCardIcon size={22} data-id="element-143" />} label="Cards" active={active === 'cards'} onClick={() => onNavigate?.('cards')} data-id="element-142" />
        <NavItem icon={<SettingsIcon size={22} data-id="element-145" />} label="Settings" active={active === 'settings'} onClick={() => onNavigate?.('settings')} data-id="element-144" />
      </div>
      <div className="flex justify-center pb-2" style={{
      backgroundColor: '#FFFFFF'
    }} data-id="element-146">
        <div className="w-[120px] h-[5px] rounded-full bg-neutral-900/80" aria-hidden="true" data-id="element-147" />
      </div>
    </div>;
}
function NavItem({
  icon,
  label,
  active,
  onClick
}: {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  onClick?: () => void;
}) {
  return <button type="button" onClick={onClick} className="flex flex-col items-center gap-1 transition-colors" style={{
    minWidth: 56,
    paddingTop: 4,
    paddingBottom: 2
  }} data-id="element-148">
      <span style={{
      color: active ? '#009AC7' : '#94A3B8'
    }} data-id="element-149">
        {icon}
      </span>
      <span style={{
      fontSize: 10.5,
      fontWeight: active ? 700 : 500,
      color: active ? '#009AC7' : '#64748B'
    }} data-id="element-150">
        {label}
      </span>
    </button>;
}